<template>
  <div id="quotationModal">
    <!-- Modal content -->
    <div class="product-modal-content" style="padding:20px;padding-bottom:50px;">
      <span class="close">&times;</span>
      <div>
        <h4 style="text-align:center;padding:20px;">Solicitar cotización</h4>
      </div>
      <div class="">
        <div class="container">
          <input 
          style="padding:8px;margin-bottom:14px;width:100%;" 
          type="text" 
          name="name" 
          placeholder="Nombre y Apellido"
          v-model="name"><br>
          <input 
          style="padding:8px;margin-bottom:14px;width:100%;" 
          type="email" 
          name="email"
          placeholder="Correo electrónico"
          v-model="email"><br>
          <input 
          style="padding:8px;margin-bottom:14px;width:100%;" 
          type="phone" 
          name="phone" 
          placeholder="Teléfono"
          v-model="phone"><br>
          <p style="color:#43a553;">{{quotationMessage}}</p><br>
        </div>
        <!-- <div>
          <p>{{getQuotation}}</p>
        </div> -->
        <div class="container">
          <button
            style="width:100%;padding:8px;cursor:pointer"
            @click.prevent="requestQuotation">Solicitar cotización
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      email: '',
      password: '',
      name: '',
      phone: '',
      quotationMessage: ''
    }
  },
  computed: {
    getQuotation () {
      return this.$store.getters.quotationItems
    }
  },
  methods: {
    requestQuotation () {
      // const items = JSON.stringify(this.getQuotation)

      let quotation = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        products: this.getQuotation
      }

      console.log(quotation)
      // console.log(items)
      // console.log(this.getQuotation)
      axios.post('http://s5.esoft.com.mx:45201/user/requestQuotation', quotation)
        .then(res => {
          console.log(res)
          this.quotationMessage = 'Su cotización ha sido enviada, pronto nos pondremos en contacto con usted.'
        })
        .catch(err => console.log(err))
    }
  }
};
</script>


<style scoped>
/* The Modal (background) */
  #quotationModal {

    position: fixed; /* Stay in place */
    z-index: 9999; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.5); /* Black w/ opacity */
    transition: opacity .3s ease;
  }

  /* Modal Content/Box */
  .product-modal-content {
    background-color: #fefefe;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    margin: 5% auto;  
    /*margin-top: 15%;*/
    /*padding: 20px;*/
    /*border: 1px solid #888;*/
    width: 400px; /* Could be more or less, depending on screen size */
  }

  .modal-content-wrapper {
    padding: 30px;
  }

  .form-product-container {
    /*background-color: rgba(0,0,0,0.4);*/
    padding: 0 !important;
  }

  /* The Close Button */
  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    display: none;
  }

  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }

  .product-info {
    font-size: 20rem;
  }

  .document-link-container {
    padding: 20px 0;
  }

  .product-info-item {
    padding: 8px 0;
    font-size: 18px;
  }

  .product-info-item span{
    font-weight: bold;
  }

  .product-document {
    color: #43a553;
    cursor: pointer;
    text-decoration: underline;
  }

</style>